export const loginForm = [
    {
      name: "apiKey",
      title: "API Key",
      type: "password",
      formRuleType: "string", 
      uiType:'input'
    },
  ];
  